import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BudgetPlannerCategoryModalPageRoutingModule } from './budget-planner-category-modal-routing.module';

import { BudgetPlannerCategoryModalPage } from './budget-planner-category-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BudgetPlannerCategoryModalPageRoutingModule
  ],
  declarations: [BudgetPlannerCategoryModalPage]
})
export class BudgetPlannerCategoryModalPageModule {}
